const PropertyAddIcon = (): JSX.Element => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6667 0.166504H3.66667C3.02325 0.166504 2.5 0.689754 2.5 1.33317V8.33317C2.5 8.97659 3.02325 9.49984 3.66667 9.49984H10.6667C11.3101 9.49984 11.8333 8.97659 11.8333 8.33317V1.33317C11.8333 0.689754 11.3101 0.166504 10.6667 0.166504ZM3.66667 8.33317V1.33317H10.6667L10.6678 8.33317H3.66667Z"
        fill="#345EA6"
      />
      <path
        d="M1.33317 3.66667H0.166504V10.6667C0.166504 11.3101 0.689754 11.8333 1.33317 11.8333H8.33317V10.6667H1.33317V3.66667ZM7.74984 2.5H6.58317V4.25H4.83317V5.41667H6.58317V7.16667H7.74984V5.41667H9.49984V4.25H7.74984V2.5Z"
        fill="#345EA6"
      />
    </svg>
  )
}

export default PropertyAddIcon;
